// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emoji-box[data-v-347a6d7d] {\n    background: #fff;\n    height: 150px;\n    width: 300px;\n    overflow: auto;\n    text-align: left;\n}\n.emoji-box ul[data-v-347a6d7d] {\n    padding: 0;\n}\n.emoji-box li[data-v-347a6d7d] {\n    display: inline-block;\n    width: 28px;\n    height: 28px;\n    line-height: 28px;\n    text-align: center;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
